<script context="module">
	const header = {
		heading: 'web.extended_warranty.header.heading',
		subheading: 'web.extended_warranty.header.subheading',
		main_image: {
			url: '/images/persons/worker.webp'
		},
		button: [
			{
				url: `${HEAT_PUMP}/${WOLTADVISOR}`,
				text: 'web.extended_warranty.header.button'
			}
		]
	}

	const boxes = [
		{
			title: {
				text: 'web.extended_warranty.boxes.box1.title',
				extrabold: true,
				red: true
			},
			description: 'web.extended_warranty.boxes.box1.description',
			icon: {
				src: '/images/icons/guarantee.webp',
				alt: 'web.extended_warranty.boxes.box1.imageAlt'
			}
		},
		{
			title: {
				text: 'web.extended_warranty.boxes.box2.title',
				extrabold: true,
				red: true
			},
			description: 'web.extended_warranty.boxes.box2.description',
			icon: {
				src: '/images/icons/tools.webp',
				alt: 'web.extended_warranty.boxes.box2.imageAlt'
			}
		},
		{
			title: {
				text: 'web.extended_warranty.boxes.box3.title',
				extrabold: true,
				red: true
			},
			description: 'web.extended_warranty.boxes.box3.description',
			icon: {
				src: '/images/icons/hand.svg',
				alt: 'web.extended_warranty.boxes.box3.imageAlt'
			}
		},
		{
			title: {
				text: 'web.extended_warranty.boxes.box4.title',
				extrabold: true,
				red: true
			},
			description: 'web.extended_warranty.boxes.box4.description',
			icon: {
				src: '/images/icons/simple/cog.svg',
				alt: 'web.extended_warranty.boxes.box4.imageAlt'
			}
		},
		{
			title: {
				text: 'web.extended_warranty.boxes.box5.title',
				extrabold: true,
				red: true
			},
			description: 'web.extended_warranty.boxes.box5.description',
			icon: {
				src: '/images/icons/simple/tools.svg',
				alt: 'web.extended_warranty.boxes.box5.imageAlt'
			}
		},
		{
			title: {
				text: 'web.extended_warranty.boxes.box6.title',
				extrabold: true,
				red: true
			},
			description: 'web.extended_warranty.boxes.box6.description',
			icon: {
				src: '/images/icons/simple/checklist.svg',
				alt: 'web.extended_warranty.boxes.box6.imageAlt'
			}
		},
		{
			title: {
				text: 'web.extended_warranty.boxes.box7.title',
				extrabold: true,
				red: true
			},
			description: 'web.extended_warranty.boxes.box7.description',
			icon: {
				src: '/images/icons/icon-podpora.svg',
				alt: 'web.extended_warranty.boxes.box7.imageAlt'
			}
		}
	]
</script>

<script>
	import { CONTACT_VARS } from '$lib/consts'
	import { HEAT_PUMP, WOLTADVISOR } from '$lib/routes'
	import { t } from '$lib/translations'
	import {
		Button,
		HeaderHero,
		IconedBoxes,
		ListItem,
		Separator,
		UnorderedList
	} from '$lib/ui-woltair/components'
	import { PUBLIC_WOLTAIR_WEB_CODE } from '$env/static/public'
</script>

<HeaderHero {header} />
<section class="page-wrapper mt-16-res">
	<Separator />
	<h2 class="pb-12-res text-center">
		{@html t('web.extended_warranty.boxes.heading')}
	</h2>
	<IconedBoxes
		--wrapper-max-width="800px"
		subtext
		column
		itemsConfig={{ minWidth: '180px', flex: '0 0 0' }}
		{boxes}
	/>
</section>

{#if PUBLIC_WOLTAIR_WEB_CODE !== 'WOLTAIR_IT'}
	<section class="page-wrapper mt-24-res">
		<Separator />
		<h2 class="pb-12-res text-center">{@html t('web.extended_warranty.lists.heading')}</h2>
		<div class="gap-15 column-m mt-5 flex justify-center">
			<div>
				<h4>{@html t('web.extended_warranty.lists.list1.heading')}</h4>
				<UnorderedList margin="mt-2">
					<ListItem>{@html t('web.extended_warranty.lists.list1.1')}</ListItem>
					<ListItem>{@html t('web.extended_warranty.lists.list1.2')}</ListItem>
					<ListItem>{@html t('web.extended_warranty.lists.list1.3')}</ListItem>
					<ListItem>{@html t('web.extended_warranty.lists.list1.4')}</ListItem>
					<ListItem>{@html t('web.extended_warranty.lists.list1.5')}</ListItem>
					<ListItem>{@html t('web.extended_warranty.lists.list1.6')}</ListItem>
					<ListItem>{@html t('web.extended_warranty.lists.list1.7')}</ListItem>
					<ListItem>{@html t('web.extended_warranty.lists.list1.8')}</ListItem>
				</UnorderedList>
			</div>
			<div>
				<h4>{@html t('web.extended_warranty.lists.list2.heading')}</h4>
				<UnorderedList margin="mt-2">
					<ListItem>{@html t('web.extended_warranty.lists.list2.1')}</ListItem>
					<ListItem>{@html t('web.extended_warranty.lists.list2.2')}</ListItem>
				</UnorderedList>
				<h4>{@html t('web.extended_warranty.lists.list3.heading')}</h4>
				<UnorderedList margin="mt-2">
					<ListItem>{@html t('web.extended_warranty.lists.list3.1')}</ListItem>
					<ListItem>{@html t('web.extended_warranty.lists.list3.2')}</ListItem>
				</UnorderedList>
			</div>
		</div>
	</section>
{/if}

<section class="page-wrapper mt-16-res">
	<Separator />
	<h2 class="mb-5 text-center">{@html t('web.extended_warranty.price.heading')}</h2>
	<div class="background-full gray py-2">
		<h2 class="mb-0 text-center text-primary-500">
			{@html t('web.extended_warranty.price.amount')}
		</h2>
		<p class="mt-0 text-center">{@html t('web.extended_warranty.price.subtext')}</p>
		{#if PUBLIC_WOLTAIR_WEB_CODE === 'WOLTAIR_IT' && new Date() <= new Date('2023-10-31')}
			<p class="text-center text-neutral-500">{@html t('web.extended_warranty.price.note')}</p>
		{/if}
	</div>
</section>
<section class="page-wrapper mt-24-res">
	<Separator />
	<h2 class="mb-5 text-center">{@html t('web.extended_warranty.options.heading')}</h2>
	<div class="gap-15 gap-m-0 contacts column-m mb-5 mt-12-res flex justify-center">
		<div class="item text">
			<p class="border-red">
				{@html t('web.extended_warranty.options.option1')}
			</p>
		</div>
		<div class="item text">
			<p class="border-red">
				{@html t('web.extended_warranty.options.option2')}
			</p>
			<div class="max-width-200 ml-6 flex flex-col items-start">
				<div class="mt-5">
					<Button href={CONTACT_VARS[PUBLIC_WOLTAIR_WEB_CODE].phoneRef}>
						{CONTACT_VARS[PUBLIC_WOLTAIR_WEB_CODE].phoneNum}
					</Button>
				</div>

				<p class="subtext mr-0 mt-0 text-left text-neutral-500">
					{@html t('web.extended_warranty.options.option2.subtext')}
				</p>
			</div>
		</div>
		<div class="item">
			<p class="border-red">
				{@html t('web.extended_warranty.options.option3')}
			</p>
			<div class="ml-6 mt-5">
				<Button href="mailto:info@woltair.cz">{CONTACT_VARS[PUBLIC_WOLTAIR_WEB_CODE].mail}</Button>
			</div>
		</div>
	</div>
</section>

<style lang="scss">
	.contacts {
		.item {
			max-width: 300px;
		}
	}
	.border-red {
		padding-left: 15px;
		border-left: 8px solid #e20613;
	}

	h2 {
		:global(span) {
			letter-spacing: -1px;
		}
	}
</style>
